import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    height: '100%',
    padding: '24px 0px 0px 24px',
  },
  toolbar: {
    paddingRight: 24,
  },
  form: {
    paddingRight: 24,
  },
  title: {
    color: '#8F91A3',
    marginBottom: 12,
    fontSize: 14,
  },
  dateField: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  dateDivider: {
    margin: '7px 10px 0',
    color: '#8F91A3',
  },
  invoiceField: {
    marginTop: 15,
  },
  supportField: {
    paddingTop: 8,
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0px 24px 24px 0px',
  },
  typesFiledHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: 8,
  },
}));
